export const CREATE_PRODUCT_OVERLAY =
  '/api/pim/overlays/create-product-overlay';
export const GET_PRODUCT_OVERLAYS_GRID =
  '/api/pim/overlays/get-product-overlay-grid';
export const GET_PRODUCT_OVERLAYS_GRID_DISTINCT =
  '/api/pim/overlays/get-product-overlay-grid/distinct';
export const DELETE_PRODUCT_OVERLAYS =
  '/api/pim/overlays/delete-product-overlays';
export const GET_ALL_OVERLAY_MEMBERS =
  '/api/pim/overlays/get-all-overlay-members';
export const RETARGET_PRODUCT_OVERLAY =
  '/api/pim/overlays/re-target-product-overlays';
export const GET_PRODUCT_OVERLAID_LIST =
  '/api/pim/overlays/get-product-overlaid-list';
export const DOWNLOAD_OVERLAYS_BULK_TEMPLATE =
  '/api/pim/overlays/download-overlays-bulk-template';
export const UPLOAD_OVERLAYS_BULK_TEMPLATE =
  '/api/pim/overlays/upload-overlays-bulk-template';

export const EXPORT_PRODUCT_OVERLAY =
  '/api/pim/overlays/get-product-overlay-grid/download';
